<template>
  <div class="spbu-landingpage">
    <adx-sidebar />
    <div class="container-router">
      <adx-jumbotron
      :image="jumbotronImg"
      :image-mobile="jumbotronImgMobile"
      :smallTitle="'ADX Asia'" 
      :title="'SPBU Advertising Now Available Exclusively'"/>
      <h1 class="header">Popular SPBU in Jakarta</h1>
      <adx-loading v-if="isLoading" slot="loading" />
      <div v-else class="spbu-landingpage__popular">
        <adx-expandable-listitems :data="data1" 
        @toggleSave="toggleSave" 
        @addToCampaign="addToCampaign"
        @goToDetail="goToDetail"
        @goToParentDetail="goToLocationDetail"
        />
        <h1 class="subhead see-all" @click="seeAll(selectedCity)">See All SPBU in Jakarta <i class="icon-chevronright color-pink"></i> </h1>
      </div>
      <h1 class="header">SPBU in other Popular city</h1>
      <div class="spbu-landingpage__city">
        <div class="spbu-landingpage__city__card" v-for="(city, index) in cities" :key="index">
          <img :src="city.image" alt="" @click="goToCity(city.key)">
          <h1 class="regular-font">{{city.name}}</h1>
        </div>
      </div>
      <h1 class="header">The Great Daily Traffic SPBU</h1>
      <adx-loading v-if="isLoading" slot="loading" />
      <div v-else class="spbu-landingpage__popular">
        <adx-expandable-listitems :data="data2" 
        @toggleSave="toggleSave" 
        @addToCampaign="addToCampaign"
        @goToDetail="goToDetail"
        @goToParentDetail="goToLocationDetail"
        />
        <h1 class="subhead see-all" @click="seeAll(null, selectedSort)">See All SPBU <i class="icon-chevronright color-pink"></i> </h1>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from "@/components/SideBar/Desktop"
import ExpandableListItems from '@/components/ExpandableListItems'
import LoadingPrimary from '@/components/Loading/Primary'
import Jumbotron from '@/components/Jumbotron/Category'

import api from '@/api'
import { apiV2 } from '@/api/urls'

export default {
  name: 'adx-discovery-spbu-landingpage',
  components: {
    "adx-sidebar": SideBar,
    'adx-expandable-listitems': ExpandableListItems,
    'adx-loading': LoadingPrimary,
    'adx-jumbotron': Jumbotron
  },
  props: {

  },
  data() {
    return {
      isLoading: false,
      selectedCity: 'jakarta',
      selectedSort: '-traffic',
      data1: null,
      data2: null,
      jumbotronImg: '/img/landingpage/SPBU-banner-new.png',
      jumbotronImgMobile: '/img/landingpage/SPBU-banner-new-mobile.png',
      cities: [
        {
          image: "/img/landingpage/SPBU-westJava.jpg",
          name: "West Java & Banten",
          key: "westJavaBanten"
        },
        {
          image: "/img/landingpage/SPBU-Jatengnjatim.jpg",
          name: "Central & East Java",
          key: "centralEastJava"
        },
        {
          image: "/img/landingpage/SPBU-sumatera.jpg",
          name: "Popular City in Sumatera",
          key: "sumatera"
        },
        {
          image: "/img/landingpage/SPBU-sulawesi.jpg",
          name: "Kalimantan & Sulawesi",
          key: "kalimantanSulawesi"
        }
      ],
      data: [
        {
          title: "Pertamina Pasar Minggu Jakarta",
          description: "This is description of Pertamina Pasar Minggu Jakarta",
          property_type_display: "Gas Station",
          street: "Jl. Raya Pasar Minggu, RT. 2 / RW. 4, Pancoran Jakarta Selatan 12780",
          cluster_name: "Pancoran",
          province_name: "DKI Jakarta",
          city_name: "Jakarta Timur",
          country_name: "Indonesia",
          zipcode: "",
          traffic: 32500,
          slug: "pasarminggu",
          category_display: "spbu",
          primary_photo: null,
          media: [
            {
              price: 2000000,
              period: null,
              placement: "Depan",
              media_name: "device",
              include_tax: false,
              description: "This is a description for SPBU",
              title: "Dummy Placement",
              photo: null
            }
          ]
        },
        {
          title: "Pertamina Kuningan Jakarta",
          description: "Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Suspendisse porttitor interdum blandit. Vivamus lorem neque, rutrum tincidunt neque a, hendrerit consequat quam. Nunc dignissim gravida dignissim. Nunc a rhoncus augue, in vulputate neque. Interdum et malesuada fames ac ante ipsum primis in faucibus. Nunc ullamcorper ornare elementum. Fusce quis tellus sed tortor porttitor malesuada et dapibus mi.",
          property_type_display: "Gas Station",
          street: "Jl. HR. Rasuna Said Kav. X2/02, Kuningan Timur Jakarta Selatan 10340",
          cluster_name: "Setia Budi",
          province_name: "-",
          city_name: "Jakarta Barat",
          country_name: "-",
          zipcode: "",
          traffic: 0,
          slug: "kuningan",
          category_display: "spbu",
          primary_photo: null,
          media: [
            {
              price: 0,
              period: null,
              placement: "depan",
              media_name: "device",
              include_tax: true,
              description: null,
              title: "Dummy Placement",
              photo: null
            }
          ]
        },
        {
          title: "Pertamina Cikini Jakarta",
          description: "Basement level, In front of Ayam Penyet, under the escalators.",
          property_type_display: "Gas Station",
          street: "Jl. Cikini Raya No. 113-115 Cikini, menteng Jakarta Pusat 10340",
          cluster_name: "Menteng",
          province_name: "-",
          city_name: "Jakarta Barat",
          country_name: "-",
          zipcode: "",
          traffic: 0,
          slug: "jurong-point-1-jurong-west-central-2-648886",
          category_display: "spbu",
          primary_photo: null,
          media: [
            {
              price: 0,
              period: null,
              placement: "Jurong Point, 1 Jurong West Central 2, 648886",
              media_name: "device",
              include_tax: false,
              description: null,
              title: "Jurong Point, 1 Jurong West Central 2, 648886",
              photo: null
            }
          ]
        }
      ],
      // Cities grouping hardcoded for a time being.
      citiesGrouping: null,
      citiesId: {
        westJavaBanten: [],
        centralEastJava: [],
        sumatera: [],
        kalimantanSulawesi: [],
        jakarta: []
      }
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {
    this.getCitiesGrouping()
  },
  beforeMount() {
    this.loadAllData()
  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    async loadAllData() {
      this.isLoading = true

      await this.loadData1()
      await this.loadData2()
      await this.loadCities()

      this.isLoading = false
    },
    async loadData1() {
      let params = {
        city: this.selectedCity,
        sort: this.selectedSort
      }
      const { data, status } = await api.get(apiV2.landingPage, { params: params })

      if (status == 200) {
        this.data1 = data
      } else {
        this.$notify({
          group: 'saved',
          title: 'Error',
          text: 'sorry something went wrong!',
          type: 'warn'
        })
      }
    },
    async loadData2() {
      let params = {
        sort: this.selectedSort
      }
      const { data, status } = await api.get(apiV2.landingPage, { params: params })

      if (status == 200) {
        this.data2 = data
      } else {
        this.$notify({
          group: 'saved',
          title: 'Error',
          text: 'sorry something went wrong!',
          type: 'warn'
        })
      }
    },
    toggleSave(list, item){
      this.$notify({
        group: 'saved',
        title: 'Added to campaign',
        text: "Saved",
        type: 'success'
      });
      console.log('toggleSave', list, item)
    },
    addToCampaign(list, item) {
      this.$notify({
        group: 'saved',
        title: 'Added to campaign',
        text: "Added to campaign",
        type: 'success'
      });
      console.log('addToCampaign', list, item)
    },
    goToDetail(item) {
      this.$notify({
        group: 'saved',
        title: 'Added to campaign',
        text: "Go To Detail",
        type: 'success'
      });
      console.log('goToDetail', item)
    },
    goToLocationDetail(list) {
      this.$router.push({name: 'detailspbuv2', params: { id: list.id}})
    },
    seeAll(city, sort) {
      if (city) this.$router.push({ name: 'resultspbu', params: { city_name: city } })

      if (sort) this.$router.push({ name: 'resultspbu', query: { sort: sort } })
    },
    goToCity(key) {
      this.$router.push({ name: 'resultspbu', params: { city_name: key.toLowerCase() }})
    },
    async loadCities() {
      const { data, status } = await api.get(apiV2.citiesList)

      if (status == 200) {
        data.forEach(obj => {
          Object.keys(this.citiesGrouping).map((key) => {
            let name = obj.name.toLowerCase()
            this.citiesGrouping[key].forEach(city => {
              if (name.includes(city)) {
                this.citiesId[key].push(obj.id)
              }
            })
          })
        });
      }
    },
    async getCitiesGrouping() {
      let file = `/static/data/cities_grouping.json`;
      (async () => {
        let request = await fetch(new Request(file));
        let { cities_grouping } = await request.json();

        this.citiesGrouping = cities_grouping
      })();
    },
  }
}
</script>

<style lang='scss'>
@import './index.scss';

.spbu-landingpage {

  .container-router {

    .categoryJumbotron__image {

      &__layer {
        border-radius: 8px;
        background-image: linear-gradient(to right, #ff5e5e, rgba(255, 174, 131, 0));

        &__content {

          i {
            display: none;
          }

          h1, h2 {
            color: $white;
          }
        }
      }
    }
  }
}

@include breakpoint (md) {
  .spbu-landingpage {

    .container-router {

      .categoryJumbotron__image-mobile {
        max-height: 200px;
      }
    }
  }
}
</style>